function alphaNumMessage (name) {
  return `The ${name} should only contain alphanumeric characters (letters A-Z, numbers 0-9)`
}

function alphaNumsMessage (name) {
  return `The ${name} should only contain alphanumeric characters (letters A-Z, numbers 0-9) and be separated by commas.`
}

function alphaSeparatorsMessage (name, separators) {
  return `The ${name} should only contain alpha characters (letters A-Z) and be separated by ${separators}`
}

function deletedMessage (className) {
  return `The ${className.toLowerCase()} was successfully deleted.`
}

function emptyMessage (name) {
  return `The ${name} can't be empty.`
}

function formatMessage (name, format) {
  return `The ${name} should have this format: ${format}`
}

function invalidMessage (name) {
  return `The ${name} is invalid.`
}

function lengthMessage (name, value) {
  return `The ${name} should be of ${value} characters long.`
}

function longMessage (name, value) {
  return `The ${name} is too long, use ${value} characters maximum.`
}

function oneOfMessage (name, values) {
  return `The ${name} should be one of ${values.join(', ')}`
}

function numberMessage (name) {
  return `The ${name} should be a number.`
}

function integerMessage (name) {
  return `The ${name} should be a number.`
}

function numberBetweenMessage (name, rangeStart, rangeEnd) {
  return `The ${name} should be a number between ${rangeStart} and ${rangeEnd}.`
}

function positiveMessage (name) {
  return `The ${name} should be a positive number.`
}

function shortMessage (name, value) {
  return `The ${name} is too short, use at least ${value} characters.`
}

function sentMessage (name) {
  return `The ${name} was successfully sent.`
}

function emailMessage () {
  return 'This does not look like a valid email address, please try again.'
}

function idsMessage () {
  return name => `These ${name} ids must be separated by commas.`
}

export {
  alphaNumMessage,
  alphaNumsMessage,
  alphaSeparatorsMessage,
  deletedMessage,
  emptyMessage,
  formatMessage,
  integerMessage,
  invalidMessage,
  lengthMessage,
  longMessage,
  numberMessage,
  numberBetweenMessage,
  oneOfMessage,
  positiveMessage,
  shortMessage,
  sentMessage,
  emailMessage,
  idsMessage
}
